// extracted by mini-css-extract-plugin
export var actions = "K5Wlc";
export var buttonGroup = "s1tOd";
export var characteristics = "Sqb-A";
export var configuration = "UIBhe";
export var downloadImageButton = "_6E5qq";
export var fallbackImage = "wqB32";
export var fallbackPreview = "rTdUy";
export var main = "VtrKU";
export var navigation = "_5nPne";
export var next = "CJNI4";
export var options = "_8lj1p";
export var preview = "IYymY";
export var previous = "_6Q9mD";
export var products = "GC80A";
export var productsCompact = "tfg+o";
export var samples = "QI3jL";
export var select = "tdypw";